import React, { useState, useEffect } from 'react';

interface FreeTextQuestionProps {
  value: string;
  onChange: (value: string) => void;
  isRequired: boolean;
  disabled?: boolean;
}

export const FreeTextQuestion: React.FC<FreeTextQuestionProps> = React.memo(({ 
  value, 
  onChange, 
  isRequired,
  disabled
}) => (
  <textarea
    className="form-control"
    rows={3}
    onChange={(e) => onChange(e.target.value)}
    value={value || ''}
    required={isRequired}
    placeholder="Type your answer here..."
    disabled={disabled}
  />
));

FreeTextQuestion.displayName = 'FreeTextQuestion';